import { render } from "./KeyValueInput.vue?vue&type=template&id=5944b315&ts=true"
import script from "./KeyValueInput.vue?vue&type=script&lang=ts"
export * from "./KeyValueInput.vue?vue&type=script&lang=ts"

import "./KeyValueInput.vue?vue&type=style&index=0&id=5944b315&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__